import type { CompletedOrder } from '@vista-digital/ocapi-types/v1'
import { OrderType } from '@vista-digital/ocapi-types/v1'
import type { CompletedGiftShopOrder } from '@vista-digital/ocapi-types/v1/types/orders/completed-orders/completed-gift-shop-order'

export function isCompletedGiftShopOrder(order: CompletedOrder | undefined): order is CompletedGiftShopOrder {
    return !!order && order.type === OrderType.GiftShop
}
